import "./utils/installCompositionApi.ts";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Axios from "axios";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { AuthenticationResult, EventType } from "@azure/msal-browser";
import { msalInstance } from "./authConfig";
import { CustomNavigationClient } from "./router/navigationClient";
import { msalPlugin } from "./plugins/msalPlugin";

Vue.use(Toast, {
  position: "bottom-right",
  timeout: 10000,
});

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;

const navigationClient = new CustomNavigationClient(router);
msalInstance.setNavigationClient(navigationClient);

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});
msalInstance.handleRedirectPromise().then(() => {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);

    const request = {
      scopes: ["openid", "profile"],
      account: accounts[0],
    };

    msalInstance
      .acquireTokenSilent(request)
      .then((tokenResponse) => {
        return tokenResponse;
      })
      .catch((e) => {
        console.error(e);
        return;
      });
  } else {
    return;
  }
});

Vue.use(msalPlugin, msalInstance);

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});
app.$mount("#app");
// inflexibility of typescript
const anyWindow = window as any;
// expose app (and thus vuex) if tests are being run
if (anyWindow.Cypress) {
  anyWindow.app = app;
}
